import React, { useEffect, useState } from "react";
import "./styles/InfoPortafolio.css";
// import CisList from './CisList';
// import LoadSimple from '../LoadSimple';
import TablePortafolioDevices from "./TablePortafolioDevices";
import Search from "../../generales/Search";


/* estilos modal crear configuracion */

const InfoPortafolio = ({
  server,
  portfolioSelected,
  onSearch,
  dataUsers,
  setDataUsers,
}) => {
  const limitList = 20;

  const [pageActual, setPageActual] = useState(1);
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const [CisAfectaModalOpen, setCisAfectaModalOpen] = useState(false);
  const [CisDocsModalOpen, setCisDocsModalOpen] = useState(false);

  const [dataCisConf, setDataCisConf] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [editActiveConfig, setEditActiveConfig] = useState(false);
  const [dataCisConfig, setDataCisConfig] = useState([]);

  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? dataCisConf.data : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  useEffect(() => {
    buscar_cis_history();
  }, []);
  function closCreateCisModal() {
    setEditActiveConfig(false);
    setCreateCisModalOpen(false);
    buscar_cis_history();
  }
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateCisModalOpen(true);
  };

  function closeCisAfectaModal() {
    setCisAfectaModalOpen(false);
  }

  function openCisAfectaModal() {
    setCisAfectaModalOpen(true);
  }
  function closeCisDocsModal() {
    setCisDocsModalOpen(false);
  }

  function openCisDocsModal() {
    setCisDocsModalOpen(true);
  }
  const handleChangEdit = (cis) => {
    setEditActiveConfig(true);
    buscar_cis(cis.conf_id);
  };
  const buscar_cis = (ci_id) => {
    // setLoadingCis(true)
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/ci_elements/history/detail/" +
            ci_id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setDataCisConfig(data1.data);
          setCreateCisModalOpen(true);
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const buscar_cis_history = () => {
    // setLoadingCis(true)
    setDataCisConf({
      data: dataCisConf.data,
      loading: true,
      error: dataCisConf.error,
    });
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/technologies/devices/" +
            portfolioSelected.tech_id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setDataCisConf({
            data: data1,
            loading: false,
            error: dataCisConf.error,
          });
          setPageActual(1);

          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  return (
    <>
      {/* {dataCisConf.loading ? (
        ""
      ) : (
        <ul>
          {dataCisConf.data.data.map((element) => (
            <li key={element.element_id}>{element.name}</li>
          ))}
        </ul>
      )} */}
      <div className="cont_info_cis">
        <div className="body_info_cis">
          <div
            className="content-mantenimiento"
            style={{ border: "px solid #607582", boxShadow: "unset" }}
          >
            <div className="cont-mantenimiento-search" style={{ background: "#0166a0" }}>
              <>
                <div className="cont-search hiddenPDF">
                  {dataCisConf.loading ? (
                    ""
                  ) : (
                    <>
                      <div className="cont-search" style={{ width: "100%" }}>
                        <Search
                          searchResults={searchResults}
                          setSearchResults={setSearchResults}
                          searchTerm={searchTerm}
                          setSearchTerm={setSearchTerm}
                          onSearch={onSearch}
                          dataObject={dataCisConf.data.data}
                          setDataObject={setDataCisConf}
                        />
                        <p style={{ color: "aliceblue", textAlign: "center" }}>
                          &nbsp;
                          {searchTerm !== ""
                            ? searchResults.length
                            : dataCisConf.data.data.length + " resultados"}
                        </p>
                      </div>
                    </>
                  )}
                </div>
                <div className="cont-search-space"></div>
              </>
            </div>

            <div className="cont-mantenimiento-table">
              <div className="content-card-mantenimiento">
                {dataCisConf.loading ? (
                  ""
                ) : (
                  <TablePortafolioDevices
                    buscar_cis_history={buscar_cis_history}
                    searchResults={searchResults}
                    server={server}
                    dataCisConf={dataCisConf}
                    searchTerm={searchTerm}
                  ></TablePortafolioDevices>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfoPortafolio;
